import { Button, Kind, Size } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { alert } from 'actions/flash'
import { ReactComponent as CopyIcon } from 'assets/images/ic-copy.svg'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

const t = buildTranslate('games')

interface BrameConfigurationDetailsProps {
  configurationData: object
}

const BrameConfigurationDetails: React.FC<BrameConfigurationDetailsProps> = ({
  configurationData,
}) => {
  const [isConfigExpanded, setIsConfigExpanded] = useState(false)
  const dispatch = useDispatch()
  const brameConfigDetailsEnabled = useFlag(
    'brame-configuration-details-enabled',
    false
  )

  const toggleConfigExpanded = () => {
    setIsConfigExpanded(!isConfigExpanded)
  }

  const copyConfigToClipboard = async () => {
    const configText = JSON.stringify(configurationData, null, 2)

    await navigator.clipboard.writeText(configText)
    dispatch(
      alert({
        key: 'success',
        message: t('enabled.notice.config_copied_to_clipboard'),
        timeout: 5,
      })
    )
  }

  if (!brameConfigDetailsEnabled) {
    return null
  }

  return (
    <div>
      <div
        className="d-flex align-items-center justify-content-between text-decoration-none"
        style={{ gap: '4px' }}
      >
        <div
          className="d-flex align-items-center"
          style={{ gap: '4px', cursor: 'pointer' }}
          onClick={toggleConfigExpanded}
        >
          <Text.BodyText4 tag="span" className="mb-0" color="primary">
            {t('enabled.notice.config_details')}
          </Text.BodyText4>
          <i
            className={`fa fa-chevron-down`}
            style={{
              transform: isConfigExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
              color: '#0070f3',
              fontSize: '12px',
            }}
          />
        </div>
      </div>
      {isConfigExpanded && (
        <div className="position-relative">
          <div
            className="position-absolute"
            style={{ top: '12px', right: '12px', zIndex: 1 }}
          >
            <Button
              kind={Kind.MINIMAL}
              size={Size.SMALL}
              onClick={copyConfigToClipboard}
              className="d-flex align-items-center"
            >
              <CopyIcon width={16} height={16} style={{ marginRight: '4px' }} />
              <span style={{ fontWeight: 'normal' }}>
                {t('enabled.notice.copy')}
              </span>
            </Button>
          </div>
          <pre
            style={{
              marginTop: '12px',
              backgroundColor: '#f8f9fa',
              padding: '12px',
              borderRadius: '4px',
              overflowX: 'auto',
              fontSize: '0.875rem',
              fontFamily: '"Courier New", monospace',
              color: '#212529',
              margin: '12px 0 0 0',
            }}
          >
            {JSON.stringify(configurationData, null, 2)}
          </pre>
        </div>
      )}
    </div>
  )
}

export default BrameConfigurationDetails
